module.exports = __webpack_public_path__ + "assets/img/tab_data@2x.fb73af24.png";